export const getFieldOptions = (fieldName, row, config, masterData = {}) => {
  const dependency = config?.dependencies?.[fieldName];

  // Normal dropdown
  if (!dependency) {
    return config?.fieldOptions?.[fieldName] || [];
  }

  // ==========================================
  // STATIC DEPENDENCY
  // ==========================================
  if (dependency.type === "static") {
    const parentField = dependency.dependsOn?.[0];

    if (!parentField) return [];

    return dependency.options?.[row?.[parentField]] || [];
  }

  // ==========================================
  // MASTER DATA DEPENDENCY
  // ==========================================
  if (dependency.type === "masterData") {
    let options = masterData?.[dependency.source] || [];

    const dependsOn = dependency.dependsOn || [];

    // Generic filtering
    options = options.filter((item) =>
      dependsOn.every((field) => {
        const selectedValue = row?.[field];

        if (
          selectedValue === undefined ||
          selectedValue === null ||
          selectedValue === ""
        ) {
          return true;
        }

        return item?.[field] === selectedValue;
      }),
    );

    return options.map((item) => ({
      label: item?.[dependency.optionLabel],
      value: item?.[dependency.optionValue],
      data: item,
    }));
  }

  return [];
};
